export const document = {
  documents: "Documents",
  CV: "CV",
  qualification: "Qualification",
  certificates: "Certificates",
  samplesOfWork: "Samples of work",
  otherDocuments: "Other documents",
  contract: "Contract",
  contract60Days: "Contract 60 days",
  contract30Days: "Contract 30 days",
};
